(() => {
  const body = document.body;
  if (!body || body.dataset.evMotion !== 'true') return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 768px)');
  const seen = new WeakSet();
  const effects = new Set();
  const banners = new Set();
  let frame = 0;
  let scanFrame = 0;
  const enabled = () => !reduced.matches && (!mobile.matches || body.dataset.evMotionMobile === 'true');
  const allowed = element => enabled() && !element.closest('[data-ev-section-motion="false"],dialog,.ev-mobile-panel');
  const number = (value, fallback) => Number.isFinite(Number(value)) ? Number(value) : fallback;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const element = entry.target;
      observer.unobserve(element);
      if (!allowed(element) || seen.has(element)) return;
      seen.add(element);
      const hero = element.matches('.ev-hero-media');
      const overflow = element.matches('.resource-list__carousel,.ev-recent-grid') && mobile.matches; 
      const card = element.closest('.product-grid__item,.ev-product-card,.ev-bike-card,.ev-collection-tile');
      let delay = 0;
      if (card?.parentElement) {
        const grid = card.parentElement;
        const tracks = getComputedStyle(grid).gridTemplateColumns;
        const columns = tracks === 'none' ? 1 : tracks.split(' ').filter(Boolean).length || 1;
        const index = [...grid.children].indexOf(card);
        delay = Math.max(0, index % columns) * number(body.dataset.evMotionStagger, 120);
      }
      const frames = overflow ? [{ transform: 'translateX(100vw)' }, { transform: 'translateX(0)' }] : hero ? [{ opacity: 0, transform: 'scale(1.3)' }, { opacity: 1, transform: 'scale(1)' }] : [{ opacity: 0 }, { opacity: 1 }];
      const animation = element.animate(frames, {
        duration: overflow ? 800 : number(hero ? body.dataset.evMotionHeroDuration : body.dataset.evMotionDuration, hero ? 2500 : 500),
        delay,
        easing: 'cubic-bezier(.26,.54,.32,1)',
        fill: 'backwards'
      });
      effects.add(animation);
      animation.finished.then(() => effects.delete(animation)).catch(() => effects.delete(animation));
    });
  }, { rootMargin: '0px 0px -60px 0px', threshold: 0 });
  const updateBanners = () => {
    frame = 0;
    banners.forEach(banner => {
      if (!banner.isConnected) { banners.delete(banner); return; }
      const media = banner.querySelector('.ev-parallax-media');
      if (!media) return;
      if (!allowed(banner)) { media.style.removeProperty('width'); media.style.removeProperty('height'); media.style.removeProperty('transform'); return; }
      const rect = banner.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const direction = banner.dataset.evDirection || 'left';
      const horizontal = direction === 'left' || direction === 'right';
      const distance = (horizontal ? rect.width : rect.height) * Math.max(0, Math.min(30, number(banner.dataset.evMovement, 15))) / 100;
      const progress = Math.min(1, Math.max(0, (innerHeight - rect.top) / (innerHeight + rect.height)));
      const offset = (direction === 'right' || direction === 'bottom' ? progress - 1 : -progress) * distance;
      media.style.width = horizontal ? `calc(100% + ${distance}px)` : '100%';
      media.style.height = horizontal ? '100%' : `calc(100% + ${distance}px)`;
      media.style.transform = horizontal ? `translate3d(${offset}px,0,0)` : `translate3d(0,${offset}px,0)`;
    });
  };
  const queue = () => { if (!frame) frame = requestAnimationFrame(updateBanners); };
  const scan = () => {
    scanFrame = 0;
    document.querySelectorAll('template[data-ev-motion-section]').forEach(marker => {
      const section = marker.closest('.shopify-section');
      if (section) section.dataset.evSectionMotion = marker.dataset.evMotionSection;
    });
    document.querySelectorAll('[data-ev-parallax="true"]').forEach(banner => { banners.add(banner); });
    if (enabled()) {
      const selectors = [];
      if (body.dataset.evMotionImages === 'true') selectors.push('.ev-parallax-media img','.ev-card-image','.ev-bike-image','.ev-collection-image','.card-gallery','.ev-media-grid article > img','.ev-media-grid article > a','.ev-review-card img','.product-media img','.cart-items__media img');
      if (body.dataset.evMotionImages === 'true' && mobile.matches) selectors.push('.resource-list__carousel');
      if (body.dataset.evMotionHero === 'true') selectors.push('.ev-hero-media');
      if (selectors.length) document.querySelectorAll(selectors.join(',')).forEach(element => {
        if (allowed(element) && !seen.has(element)) observer.observe(element);
      });
    }
    queue();
  };
  const reset = () => {
    observer.disconnect();
    effects.forEach(effect => effect.cancel());
    effects.clear();
    body.classList.toggle('ev-motion-active', enabled());
    scan();
  };
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length || record.removedNodes.length) && !scanFrame) scanFrame = requestAnimationFrame(scan);
  }).observe(body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:select', event => {
    effects.forEach(effect => { if (event.target.contains(effect.effect?.target)) effect.finish(); });
  });
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue, { passive: true });
  reduced.addEventListener('change', reset);
  mobile.addEventListener('change', reset);
  reset();
})();
